export const CSV_MIME = "text/csv";
export const XLSX_MIME =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const PDF_MIME = "application/pdf";
export const ZIP_MIME = "application/zip";
